import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/python': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M167.8 36.4C122.6 44.4 114.4 61.1 114.4 92V132.7H221.3V146.3H74.3C43.2 146.3 16 165 7.5 200.5-2.3 241.2-2.7 266.6 7.5 309.1 15.1 340.7 33.2 363.3 64.3 363.3H101V314.5C101 279.2 131.5 248.1 167.8 248.1H274.6C304.3 248.1 328 223.6 328 193.8V91.9C328 62.9 303.6 41.2 274.6 36.3 238.8 30.4 199.9 30.7 167.8 36.4zM161.1 64.8C172.1 64.8 181.2 74 181.2 85.2S172.2 105.5 161.1 105.5C150 105.5 141 96.4 141 85.2 141.1 73.9 150 64.8 161.1 64.8zM346.3 146.2V193.7C346.3 230.5 315.1 261.5 279.5 261.5H172.7C143.5 261.5 119.3 286.5 119.3 315.8V417.6C119.3 446.6 144.5 463.6 172.7 471.9 206.5 481.8 239 483.6 279.5 471.9 306.4 464.1 332.9 448.4 332.9 417.6V376.9H226.2V363.3H386.4C417.5 363.3 429 341.6 439.8 309.1 451 275.6 450.5 243.4 439.8 200.5 432.1 169.6 417.5 146.3 386.4 146.3H346.3zM286.2 404C297.3 404 306.3 413.1 306.3 424.3 306.3 435.6 297.3 444.7 286.2 444.7 275.2 444.7 266.1 435.5 266.1 424.3 266.2 413 275.2 404 286.2 404z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/python.js
// module id = iGew
// module chunks = 144